import React, { FC, useState } from 'react';
import { Col, FormFeedback, Input, Label } from 'reactstrap';
import Select from 'react-select';
import { restrictSpace } from '../Common/Util';

import { fileSizeOptions, PhoneNumberCodes } from 'Components/Common/FormSchemas/FormSchema';

interface InputGroupComponentProps {
    field: {
        xs?: number;
        sm?: number;
        md?: number;
        lg?: number;
        xl?: number;
        label: string;
        value: string;
        mandatory?: boolean;
        disabled?: boolean;
        isMulti?: boolean;
        isClearable?: boolean;
        inputgroupKey: string;
        type: string | any;
        maxLen?: number;
        regex?: any;
        isFileSizeField?: boolean;
    };
    labelCss?: string;
    mode: string;
    validation: {
        values: any;
        handleChange: (event: React.ChangeEvent<HTMLInputElement> | any) => void;
        touched: any;
        errors: any;
        handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
        setFieldValue: any;
    };
    handlepattern?: any;
    schemaRegex?: string;
}

const InputGroupComponent: FC<InputGroupComponentProps> = (props) => {
    const [numberLength, setNumberLength] = useState(null);
    const [field, setField] = useState(props?.field);

    const onHandleChange = (selectedOption: any) => {
        setNumberLength(selectedOption.maxLen);
        setField({ ...field, regex: selectedOption.validationPattern });
        props?.handlepattern(selectedOption);
        props.validation.setFieldValue(field.inputgroupKey, selectedOption);
    };

    return (
        <Col xs={props.field?.xs} sm={props.field?.sm} md={props.field?.md} lg={props.field?.lg} xl={props.field?.xl}>
            <div className="mt-2">
                {props.field?.label && (
                    <Label htmlFor={props.field?.value} className={`form-label m-0 ${props.labelCss && props.labelCss}`}>
                        {props.field.label}
                        {props.mode !== 'view' && <span className="text-danger ps-1"> {props.field.mandatory ? '*' : ''}</span>}
                        {props.mode === 'view' && <span className="ps-1"> :</span>}
                    </Label>
                )}
                {props.mode === 'view' ? (
                    <span className="ps-1"> {props.validation.values[props.field?.value] || ''}</span>
                ) : (
                    <div className="input-group mt-2">
                        <span className=" p-0 me-2 bg-white border-none">
                            <Select
                                // styles={{
                                //     control: (styles: any, state: { selectProps: { isDisabled: any } }) => ({
                                //         ...styles,
                                //         backgroundColor: state.selectProps.isDisabled ? '#f2f2f2' : 'white'
                                //     }),
                                //     menu: (styles: any) => ({ ...styles, backgroundColor: 'white', zIndex: 999999, lineBreak: 'anywhere' }),
                                //     option: (styles: any, { isSelected, isFocused }: any) => ({
                                //         ...styles,
                                //         backgroundColor: isSelected ? '#048c71' : isFocused ? '#9dc9bd' : 'white',
                                //         color: isSelected ? 'white' : '#000000'
                                //     }),
                                //     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                                // }}
                                getOptionValue={(option: { value: any }) => option.value}
                                getOptionLabel={(option: { label: any }) => option.label}
                                autoFocus={false}
                                isDisabled={props.field?.disabled}
                                isMulti={props.field.isMulti ? true : false}
                                isClearable={props.field.isClearable ? true : false}
                                id={props.field.label}
                                name={props.field.inputgroupKey}
                                // options={[{ label: '+1', value: '+1' }]}
                                options={props?.field?.isFileSizeField ? fileSizeOptions : PhoneNumberCodes}
                                onChange={(selectedOption: any) => onHandleChange(selectedOption)}
                                value={
                                    props?.field?.isFileSizeField ? 
                                    props.validation?.values[props.field.inputgroupKey] || {
                                        label: 'KB',
                                        value: 'KB',
                                        maxLen: '10'
                                    } 
                                    : 
                                    props.validation?.values[props.field.inputgroupKey] || {
                                        label: 'India(+91)',
                                        value: '+91',
                                        validationPattern: '^[6789]\\d{9}$',
                                        maxLen: '10'
                                    }



                                   
                                }
                                isSearchable={false}
                                placeholder={'Ex : +1'}
                                noOptionsMessage={() => 'No data found'}
                                classNamePrefix={`border-none ${
                                    props.validation.touched[props.field?.inputgroupKey] &&
                                    props.validation.errors[props.field?.inputgroupKey]
                                        ? 'border-danger border-none'
                                        : null
                                }`}
                                menuPortalTarget={document.body}
                                menuPosition={'absolute'}
                                menuPlacement={'bottom'}
                            />
                        </span>
                        <Input
                            className="form-control"
                            name={props.field?.value}
                            type={props.field?.type}
                            placeholder={`${'Enter'} ${props.field.label}`}
                            disabled={props.field?.disabled}
                            onChange={props.validation.handleChange}
                            autoComplete="off"
                            // maxLength={props.field?.maxLen}
                            maxLength={numberLength ? parseInt(numberLength) : 10}
                            onBlur={props.validation.handleBlur}
                            value={props.validation.values[props.field?.value] || ''}
                            invalid={
                                props.validation.touched[props.field?.value] && props.validation.errors[props.field?.value] ? true : false
                            }
                            onKeyDown={(ev) => restrictSpace(ev, props.field)}
                        />
                        {props.validation.touched[props.field?.value] && props.validation.errors[props.field?.value] ? (
                            <FormFeedback type="invalid">
                                <div>{props.validation.errors[props.field?.value]}</div>
                            </FormFeedback>
                        ) : null}
                    </div>
                )}
            </div>
        </Col>
    );
};

export default InputGroupComponent;
